import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "../v2/apiService";

export async function UserSocialSignOn(payload) {
  return await apiService.apiCallWithoutToken(
      endPoints.SOCIAL_SIGNON_V2,
    "POST",
    payload
  );
}
